module.exports = __webpack_public_path__ + "static/favicon-160fbfefdfe2ec209d4a226a59ca1d3b.ico";